import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { BaseChartComponent } from "./base-chart.component";
import { ChartConfiguration } from "chart.js/auto";
import { StationDto } from "src/app/services/api";
import { PRIMARY_LINE_COLOR } from "src/app/constants/index";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-precipitation-chart",
  templateUrl: "./chart.component.html",
  styleUrls: ["./chart.component.scss"],
})
export class PrecipitationChartComponent extends BaseChartComponent implements OnChanges {
  @Input() public precipitationLast1h!: string;
  @Input() public precipitationLast24h!: string;
  @Input() public stations?: StationDto[];

  constructor(translate: TranslateService, cdr: ChangeDetectorRef) {
    super(translate, cdr);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    // Update the data property for app-empty-data component
    if (this.data?.length) {
      // Force chart re-rendering when data changes
      if (changes.data && this.chartContainer) {
        setTimeout(() => {
          this.renderChart();
          this.cdr.detectChanges();
        }, 0);

        // Call parent's ngOnChanges to ensure base component logic runs
        super.ngOnChanges(changes);
        return;
      }
    }

    // Call parent's ngOnChanges to ensure base component logic runs
    super.ngOnChanges(changes);
  }

  protected getChartConfig(): ChartConfiguration {
    const transformedData = this.data
      .map(point => ({
        x: new Date(point.timestamp).getTime(),
        y: Math.max(point.value, 0),
      }))
      .reverse();

    const xSuggestedMax = !this.currentTime ? new Date().getTime() : null;
    const ySuggestedMax = 10; // REVISAR

    const commonOptions = this.getCommonChartOptions(xSuggestedMax, ySuggestedMax, " mm");

    return {
      type: "bar",
      data: {
        datasets: [
          {
            data: transformedData,
            borderColor: PRIMARY_LINE_COLOR,
            backgroundColor: PRIMARY_LINE_COLOR,
            borderWidth: 2,
            pointRadius: 1,
            tension: 0.5,
            minBarLength: 2,
            parsing: false,
          },
        ],
      },
      options: {
        ...commonOptions,
        // Se pueden agregar o modificar opciones específicas para este gráfico
      },
      plugins: [],
    };
  }
}
